import { render } from "./ContatoView.vue?vue&type=template&id=18b27ed2&scoped=true"
import script from "./ContatoView.vue?vue&type=script&lang=js"
export * from "./ContatoView.vue?vue&type=script&lang=js"

import "./ContatoView.vue?vue&type=style&index=0&id=18b27ed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b27ed2"]])

export default __exports__